export default function useLongPress() {
  return function (startCallback: Function) {
    let timeout: any = null;
    let preventClick = false;

    function start() {
      timeout = setTimeout(() => {
        preventClick = true;
        startCallback();
      }, 250);
    }

    function clear() {
      timeout && clearTimeout(timeout);
      preventClick = false;
    }

    function clickCaptureHandler(e: any) {
      if (preventClick) {
        e.stopPropagation();
        preventClick = false;
      }
    }

    return {
      onMouseDown: start,
      onTouchStart: start,
      onMouseUp: clear,
      onMouseLeave: clear,
      onTouchMove: clear,
      onTouchEnd: clear,
      onClickCapture: clickCaptureHandler
    };
  }
}